import { Button, Col, Form, Input, InputNumber, Modal, ModalProps, notification, Row } from "antd";
import { cloneElement, ReactNode, useState } from "react";
import { useNotaEmitir } from "../../../../../Services/Financeiro/Titulo/NotaService";
import { PropriedadesDeNotificacao } from "../../../../../Utils/Notificacoes";
import { Nota } from "../../../../../Models/Financeiro/Titulo/Nota";
import ServicoSelect from "../../Faturamento/Servico/ServicoSelect";
import dayjs from 'dayjs';
import ComponentePermissao from "../../../../Base/Permissao/ComponentePermissao";
import InputDate from "../../../../Base/Input/InputDate";

interface INotaEmitirFormModalProps extends ModalProps {
    buttonOpen?:ReactNode;
    nota:Nota;
    onSuccess?:() => void;
}
export default function NotaEmitirFormModal({
    title,
    destroyOnClose,
    okText,
    nota,
    buttonOpen,
    onSuccess,
    ...props
}:INotaEmitirFormModalProps) {
    const [ aberta, setAberta ] = useState(false);
    const [ form ] = Form.useForm<Nota>();
    
    const {
        mutate,
        isPending
    } = useNotaEmitir({
        onSuccess(data, variables, context) {
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Nota emitida com sucesso."
            });
            onSuccess?.();
            fecharModal();
        },
    });
    function abrirModal() {
        setAberta(true);
    }
    function fecharModal() {
        form.resetFields();
        setAberta(false);
    }
    return <ComponentePermissao permissoes={["FinanceiroTituloNotaEmitir"]}>
        {
            buttonOpen 
            && cloneElement(buttonOpen as React.ReactElement<any>, { onClick : abrirModal }) 
            || <Button type="primary" size="small" onClick={abrirModal}>Emitir</Button>
        }
        <Modal
            {...props}
            open={aberta}
            title={title ?? "Emitir nota"}
            onOk={form.submit}
            okText={okText ?? "Emitir"}
            confirmLoading={isPending}
            onCancel={fecharModal}
            destroyOnClose={destroyOnClose ?? true}
        >
            <Form<Nota>
                form={form}
                onFinish={mutate}
                layout="vertical"
                autoComplete="off"
                initialValues={{
                    ...nota,
                    dataCompetencia : dayjs(nota.dataCompetencia),
                    codServico : nota.codServico <= 0 ? undefined : nota.codServico
                } as Nota}
            >
                <Row gutter={8} wrap>
                    <Form.Item<Nota> hidden label={"Titulo"} name={"codTitulo"} rules={[ { required : false } ]}></Form.Item>
                    <Form.Item<Nota> hidden label={"Nota"} name={"codigo"} rules={[ { required : false } ]}></Form.Item>
                    <Col xs={24}>
                        <Form.Item<Nota> label={"Serviço"} name={"codServico"} rules={[
                            {
                                required : true,
                                message : "Por favor, insira Serviço"
                            }
                        ]}>
                            <ServicoSelect />
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item<Nota> 
                            label="Competência" 
                            name={"dataCompetencia"}
                            rules={[ { required : true } ]}
                        >
                            <InputDate />
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item<Nota> 
                            label="Valor" 
                            name={"valor"}
                            rules={[ { required : true } ]}
                        >
                            <InputNumber<number>
                                style={{ width: "100%" }} 
                                min={0} 
                                precision={2}
                                controls={false} 
                                placeholder="Valor (R$)" 
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item<Nota> 
                            label="Informações adicionais" 
                            name={"informacaoAdicional"}
                            rules={[ { required : false, max : 500 } ]}
                        >
                            <Input.TextArea
                                maxLength={500}
                                placeholder="Informação adicional" 
                                style={{ width: "100%" }}
                                allowClear={true}
                                rows={4}
                            ></Input.TextArea>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    </ComponentePermissao>
}